import { IBaseResponse, ICenterBase, IContact, IFollowUpDonor, IListItem } from '@nkr/models/index';
import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from '../';

export interface IExistingDashRegistration {
    id: number,
    firstName: string,
    lastName: string,
    fullName: string,
    addressLine1: string,
    city: string,
    state: string,
    postalCode: string,
    nonUsStateProvince: string,
    country: string,
    phone: string,
    birthDate: string,
    donationDate: string,
    email: string,
    heightInches: number,
    weightLbs: number
}

export interface IExistingDonor {
    id: number,
    firstName: string,
    lastName: string,
    fullName: string,
    addressLine1: string,
    city: string,
    state: string,
    postalCode: string,
    phone: string,
    birthDate: string,
    donationDate: string,
    email: string,
    heightInches: number,
    weightLbs: number
}

export interface IFollowUpDonorResponse {
    data: {
        success: boolean,
        message: string,
        results: IFollowUpDonor
    }
}

export interface IFollowUpDonorLookupDataResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            coordinatorList: IContact[],
            countryList: IListItem[],
            stateList: IListItem[],
            genderList: IListItem[],
            centerList: ICenterBase[],
            followUpSurveyInstanceList: IListItem[]
        }
    }
}

export interface IFollowUpDonorVerifyEmailResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            hasExistingRegistration: boolean
        }
    }
}

export interface IFollowUpDonorRecordsByEmailResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            existingRegistrationsList: IExistingDashRegistration[],
            existingDonorsList: IExistingDonor[]
        }
    }
}

export interface IFollowUpDonorSaveResponse {
    data: {
        success: boolean,
        message: string,
        results: number
    }
}

export const ActionCreators = {
    getDonor: (donorId:number) => async (dispatch: Dispatch<IApplicationState>): Promise<IFollowUpDonorResponse> => {
        let options = {
            url: `${__API__}/follow-up/donor/${donorId}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getLookupData: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IFollowUpDonorLookupDataResponse> => {
        let options = {
            url: `${__API__}/follow-up/donor/lookup-data?centerId=${centerId}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    verifyEmail: (centerId: number, email: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IFollowUpDonorVerifyEmailResponse> => {
        let options = {
            url: `${__API__}/follow-up/donor/verify-email`,
            data: {
                centerId,
                email
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    getRecordsByEmail: (centerId: number, email: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IFollowUpDonorRecordsByEmailResponse> => {
        let options = {
            url: `${__API__}/follow-up/donor/records-by-email`,
            data: {
                centerId,
                email,
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    insert: (
        centerId: number,
        email: string,
        mrn: string,
        surveyInstanceSkip: number,
        phone: string,
        firstName: string, lastName: string,
        country: number, addressLine1: string, city: string, state: number, nonUsStateProvince: string, postalCode: string,
        gender: number,
        birthDate: string, donationDate: string,
        heightInches: number, weightLbs: number,
        registrationId: number, coordinatorContactId: number,
        hasEmail: boolean
    ) => async (dispatch: Dispatch<IApplicationState>): Promise<IFollowUpDonorSaveResponse> => {
        let options = {
            url: `${__API__}/follow-up/donor/insert`,
            data: {
                centerId,
                email,
                mrn,
                surveyInstanceSkip,
                phone,
                firstName, lastName,
                country, addressLine1, city, state, nonUsStateProvince, postalCode,
                gender,
                birthDate, donationDate,
                heightInches, weightLbs,
                registrationId,
                coordinatorContactId,
                hasEmail
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    update: (
        id: number,
        centerId: number,
        email: string,
        mrn: string,
        surveyInstanceSkip: number,
        phone: string,
        firstName: string, lastName: string,
        country: number, addressLine1: string, city: string, state: number, nonUsStateProvince: string, postalCode: string,
        gender: number,
        birthDate: string, donationDate: string,
        heightInches: number, weightLbs: number,
        registrationId: number,
        coordinatorContactId
    ) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/follow-up/donor/${id}/update`,
            data: {
                centerId,
                email,
                mrn,
                surveyInstanceSkip,
                phone,
                firstName, lastName,
                country, addressLine1, city, state, nonUsStateProvince, postalCode,
                gender,
                birthDate, donationDate,
                heightInches, weightLbs,
                registrationId,
                coordinatorContactId
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPut(options));
        } catch (error) {
            throw error;
        }
    },
}